import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import axios from "axios";
import Constants from "Utils/Constants";
import Header from "Common/Header";
import { getWrappedJSON } from "Utils/Common";
import { goToRunningTasksAdmin } from "RunningTasksAdmin";
import { withRouter, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";
import store from "store";
import Toolbar from "@material-ui/core/Toolbar";
import Card from "@material-ui/core/Card";
import { ToolbarButton } from "Common/ToolbarButton";
import AccountsTable from "./AccountsTable";
import AccountsTableOld from "./AccountsTableOld";
import { AddCreditsRows } from "./AddCreditsRows";
import { AddUserRows } from "./AddUserRows";
import { SetMaxThreadsRow } from "./SetMaxThreadsRow";

export default withRouter(function() {
  const [adminpage, setAdminpage] = React.useState(null);
  let history = useHistory();
  const user = useSelector(({ rootScope }) => rootScope.user);
  const isAdmin = user.roles.isAdmin;
  const isAllowedChats = user.roles.isAllowedChats;

  function openAdminPage() {
    store.dispatch({ type: "ISLOADING", payload: true });
    var dataparams = getWrappedJSON({
      action: "getdata",
      dataparams: { datakey: "adminpage" },
    });
    axios.post(Constants.dotaskactionApiPath, dataparams).then((response) => {
      setAdminpage(response.data.data.adminpage);
      store.dispatch({ type: "ISLOADING", payload: false });
    });
  }

  React.useEffect(() => {
    openAdminPage();
  }, []);

  let activeAccounts = 0;
  let totalUsers = 0;
  let totalAccounts = 0;
  let totalServers = 0;
  let activeServers = 0;
  let activeUsers = 0;

  if (adminpage) {
    var adminPageKeys = Object.keys(adminpage.usersdata);
    totalUsers = adminPageKeys.length;
    adminPageKeys.map((key) => {
      const value = adminpage.usersdata[key];
      const emails = value.emails;
      let isUserActive = false;
      Object.keys(emails).map((key2) => {
        const { servers, duration, refillstampmillis } = value.emails[key2];
        totalAccounts++;
        totalServers += servers.length;
        const currentMillis = new Date().getTime();
        const endTime = parseInt(refillstampmillis) + parseInt(duration) * 1000;
        let active = false;
        if (endTime > currentMillis) {
          active = true;
          isUserActive = true;
        }
        if (active) {
          activeAccounts++;
          activeServers += servers.length;
        }
      });
      if (isUserActive) {
        activeUsers++;
      }
    });
  }

  return (
    <div>
      <Header />
      <br />
      <Toolbar
        style={getStyleJSON(
          `background-color: var(--menubarbackgroundcolor);min-height: auto;`
        )}
      >
        <div layout="row" className="layout-row">
          <div>
            <ToolbarButton
              label={"Refresh"}
              onClick={openAdminPage}
              tooltip={"Refresh Admin Data."}
            />
            {false && isAllowedChats && (
              <div
                style={getStyleJSON("display: inline-block")}
                className="ng-scope"
              >
                <ToolbarButton
                  label={"Chat api"}
                  onClick={"goToChatApi()"}
                  tooltip={"Access Chat api."}
                />
              </div>
            )}
            {isAdmin && (
              <div
                style={getStyleJSON("display: inline-block")}
                className="ng-scope"
              >
                <ToolbarButton
                  label={"Running Tasks(Admin)"}
                  onClick={() => goToRunningTasksAdmin(history)}
                  tooltip={""}
                />
              </div>
            )}
          </div>
        </div>
      </Toolbar>
      <br />
      {!adminpage && <LinearProgress color="secondary" />}

      {adminpage && (
        <div className="komform">
          <Card
            style={{
              width: "fit-content",
              height: "auto",
              padding: "10px 16px 16px 16px",
              margin: "10px",
            }}
          >
            <div className="infokey">Running Threads</div>
            <div className="infovalue">
              {adminpage.threadpoolrunningtasks}/
              {adminpage.maxthreadpoolrunningtasks}
            </div>
            <div className="infokey">Task Manager User Cache</div>
            <div className="infovalue">{adminpage.taskmanagerusercache}</div>
          </Card>

          <table
            align="center"
            style={getStyleJSON("width: 300px")}
            cellSpacing="0"
            cellPadding="0"
          >
            <tbody>
              <SetMaxThreadsRow />
              <AddCreditsRows />
              <AddUserRows />
              {Constants.showNewTable && (
                <>
                  <div
                    style={{ width: "max-content" }}
                  >{`Total Users: ${totalUsers} (${activeUsers} active, ${totalUsers -
                    activeUsers} inactive)`}</div>
                  <div
                    style={{ width: "max-content" }}
                  >{`Total Accounts: ${totalAccounts} (${activeAccounts} active, ${totalAccounts -
                    activeAccounts} inactive)`}</div>
                  <div
                    style={{ width: "max-content" }}
                  >{`Total Servers: ${totalServers} (${activeServers} active, ${totalServers -
                    activeServers} inactive)`}</div>
                  <div
                    style={{ width: "max-content" }}
                  >{`Total Active Credit(USD): ${activeAccounts *
                    9.18} $`}</div>
                  <div
                    style={{ width: "max-content" }}
                  >{`Total Active Credit(Approx INR): ~ ${activeAccounts *
                    9.18 *
                    70} ₹`}</div>
                </>
              )}
            </tbody>
          </table>
          <br />
          <br />
          {!Constants.showNewTable && <AccountsTableOld data={adminpage} />}
          {Constants.showNewTable && (
            <AccountsTable
              data={adminpage.usersdata}
              usercachereport={adminpage.usercachereport}
            />
          )}
        </div>
      )}
    </div>
  );
});
